import { Injectable, TemplateRef } from '@angular/core'
import * as moment from 'moment'
import {
  DEFAULT_PAGE_SIZE,
  FILTER_CONDITIONS,
} from 'src/app/shared-components/constants'

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private getFileUploadFilterValue(
    filterColumn: string,
    filterValue: string
  ): string {
    switch (filterValue) {
      case 'Unavailable':
      case 'No':
        return `!*${filterColumn}=null`
      case 'Available':
      case 'Yes':
        return `!*${filterColumn}=nnull`
      default:
        return ''
    }
  }

  getRequestUrl(
    pageNumber?,
    sort?,
    searchParams?,
    totalRecords?,
    excludePagination?: boolean
  ) {
    if (sort && sort.direction == '') {
      sort.direction = ''
      sort.active = ''
    }
    const defaultPayload = {
      page: 1,
      size: DEFAULT_PAGE_SIZE,
    }
    if (
      searchParams &&
      Array.isArray(searchParams) &&
      searchParams.length > 0
    ) {
      let searchUrl = ``
      searchParams.forEach((param) => {
        if (param.filterCondition === 'DateCondition') {
          const fromDate = param.filterValue.fromDate
          const toDate = param.filterValue.toDate
          if (fromDate != '' && (toDate == '' || toDate == undefined)) {
            const fromFilterDate = moment(fromDate).format('YYYY-MM-DD')
            searchUrl += `!*${param.filterColumn}=gte:${fromFilterDate}`
          } else if (
            toDate != '' &&
            (fromDate == '' || fromDate == undefined)
          ) {
            const toFilterDate = moment(toDate).format('YYYY-MM-DD')
            searchUrl += `!*${param.filterColumn}=lte:${toFilterDate}`
          } else if (
            (fromDate != '' || fromDate != undefined) &&
            (toDate != '' || toDate != undefined)
          ) {
            const fromFilterDate = moment(fromDate).format('YYYY-MM-DD')
            const toFilterDate = moment(toDate).format('YYYY-MM-DD')
            searchUrl += `!*${param.filterColumn}=gte:${fromFilterDate}!*${param.filterColumn}=lte:${toFilterDate}`
          }
        } else if (
          param.filterCondition === FILTER_CONDITIONS.IS_NULL ||
          param.filterCondition === FILTER_CONDITIONS.IS_NOT_NULL
        ) {
          const condition = this.getConditions(param.filterCondition)
          searchUrl += `!*${param.filterColumn}=${condition}`
        } else if (param.filterCondition == 'file-upload') {
          searchUrl += this.getFileUploadFilterValue(
            param.filterColumn,
            param.filterValue
          )
        } else if (
          param.filterColumn === 'DocumentTypes' &&
          ((typeof param.filterValue === 'string' &&
            param.filterValue.includes('Blank')) ||
            (Array.isArray(param.filterValue) &&
              param.filterValue.includes('Blank')))
        ) {
          searchUrl += `!*${param.filterColumn}=null`
        } else {
          const condition = this.getConditions(param.filterCondition)
          searchUrl += `!*${param.filterColumn}=${condition}:${param.filterValue}`
        }
      })
      if (searchUrl.startsWith('!*')) {
        searchUrl = searchUrl.substring(2)
      }
      if (sort.direction != '' && sort.active != '' && sort.active != null) {
        searchUrl += `!*sort=${sort.direction}:${sort.active}`
      }
      const encodedUrl = encodeURIComponent(searchUrl.trim())

      if (excludePagination) {
        return `?qs=${encodedUrl}`
      }

      const requestURl =
        typeof pageNumber === 'number'
          ? `?page=${totalRecords ? 1 : pageNumber + 1}&size=${totalRecords ? totalRecords : defaultPayload.size}&qs=${encodedUrl}`
          : `?page=${defaultPayload.page}&size=${defaultPayload.size}&qs=${encodedUrl}`
      return requestURl
    }
    if (typeof pageNumber === 'number' && sort.active === '') {
      if (excludePagination) {
        return ''
      }
      const requestURl = `?page=${pageNumber + 1}&size=${defaultPayload.size}`
      return requestURl
    } else if (
      sort &&
      sort.direction != '' &&
      sort.active != '' &&
      sort.active != null
    ) {
      const encodedSortUrl = encodeURIComponent(
        `sort=${sort.direction}:${sort.active}`
      )

      if (excludePagination) {
        return `?qs=${encodedSortUrl}`
      }

      const requestURl = pageNumber
        ? `?page=${pageNumber + 1}&size=${defaultPayload.size}&qs=${encodedSortUrl}`
        : `?page=${defaultPayload.page}&size=${defaultPayload.size}&qs=${encodedSortUrl}`
      return requestURl
    } else {
      if (excludePagination) {
        return ''
      }
      const requestURl = `?page=${defaultPayload.page}&size=${defaultPayload.size}`
      return requestURl
    }
  }

  getConditions(condition): string {
    switch (condition) {
      case FILTER_CONDITIONS.IS_EQUAL_TO:
        return 'eq'
        break
      case FILTER_CONDITIONS.IS_NOT_EQUAL_TO:
        return 'ne'
        break
      case FILTER_CONDITIONS.CONTAINS:
        return 'cts'
        break
      case FILTER_CONDITIONS.DOES_NOT_CONTAIN:
        return 'dnc'
        break
      case FILTER_CONDITIONS.STARTS_WITH:
        return 'sw'
        break
      case FILTER_CONDITIONS.ENDS_WITH:
        return 'ew'
        break
      case FILTER_CONDITIONS.IS_GREATER_THAN:
        return 'gt'
        break
      case FILTER_CONDITIONS.IS_GREATER_THAN_OR_EQUAL_TO:
        return 'gte'
        break
      case FILTER_CONDITIONS.IS_LESS_THAN:
        return 'lt'
        break
      case FILTER_CONDITIONS.IS_LESS_THAN_OR_EQUAL_TO:
        return 'lte'
        break
      case FILTER_CONDITIONS.IS_NULL:
        return 'null'
        break
      case FILTER_CONDITIONS.IS_NOT_NULL:
        return 'nnull'
        break
      case FILTER_CONDITIONS.BETWEEN:
        return 'btw'
        break
    }
  }
  templates: { [name: string]: TemplateRef<any> } = Object.create(null)
}
